import { SendMessagePayload } from '../models/assistant.model';

export class LoadConversations {
  static readonly type = '[Assistant] Load Conversations';
}
export class CreateConversation {
  static readonly type = '[Assistant] Create Conversation';
}
export class SelectConversation {
  static readonly type = '[Assistant] Select Conversation';
  constructor(public id: string) {}
}
export class SendMessage {
  static readonly type = '[Assistant] Send Message';
  constructor(public payload: SendMessagePayload) {}
}
export class DeleteConversation {
  static readonly type = '[Assistant] Delete Conversation';
  constructor(public id: string) {}
}
export class SetTyping {
  static readonly type = '[Assistant] Set Typing';
  constructor(public typing: boolean) {}
}
